<template>
  <div id="my-report">
    <div class="container">
      <div class="contents">
        <div class="button button-float" @click="onShareClick">Share</div>

        <div
          class="character"
          :style="{ backgroundImage: `url(${userCharacterImgURL})` }"
        ></div>
        <div class="type">{{ userType }}</div>
        <p>
          {{ summaryReport }}
        </p>
      </div>
      <div class="button-group">
        <div class="button" @click="onReadMoreClick">Read More</div>
        <p style="font-size: 0.625em; text-align: center">or</p>
        <div class="button" @click="onGetFullReportClick">
          Get A Full Report
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common'
import ReportService from '@/services/report-service'

export default {
  name: 'Signup',
  mixins: [common],
  data() {
    return {
      pageTitle: 'My Report',

      userCharacterImgURL: null,
      userType: '',
      summaryReport: ''
    }
  },
  created() {
    this.$parent.setNav(true)
    this.$parent.setHeader(this.pageTitle)
    this.$parent.headerBack = true
    this.$parent.setBottomTab(false)

    this.performGetMyReport()
  },
  methods: {
    performGetMyReport() {
      ReportService.getMyReport().then(({ resultCode, resultData }) => {
        if (resultCode === 0 && !this.isEmpty(resultData)) {
          this.userCharacterImgURL = `${process.env.VUE_APP_API_BASE_URL}${resultData.image}`
          this.userType = resultData.type
          this.summaryReport = resultData.overview
        }
      })
    },
    onShareClick() {
      this.$parent.shareDialog = true
    },
    onReadMoreClick() {
      this.goPage('reportdetail')
    },
    onGetFullReportClick() {
      this.goPageWithParams('Payment', { paymentTab: 'report' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/my-report.scss" scoped></style>
